module.exports = __webpack_public_path__ + "img/4.889ae364.png";